<template>
  <section>
    <h2 class="sub-title">
      {{ UserSearch.searchRunner[lang] }}
    </h2>
    <form
      action=""
      @submit="runner"
      method="get"
      id="js-form"
      class="search-form"
    >
      <input
        type="hidden"
        name="event"
        v-bind:value="this.$route.query.event"
      />
      <input type="hidden" name="page" value="1" />
      <label>
        <input
          v-model="modelUserSearch"
          class="search-box"
          :class="{ alert: isSearchAlert }"
          type="text"
          :placeholder="UserSearch.placeholder[lang]"
          autocomplete="on"
          required
        />
      </label>
      <div class="search-button">
        <button type="submit" class="button">
          <img src="../../../assets/images/mushimegane.svg" alt="" />
          <span>
            {{ UserSearch.search[lang] }}
          </span>
        </button>
      </div>
    </form>
  </section>
</template>

<script>
import UserSearch from "../../../assets/constants/ranking/userSearch";
export default {
  data() {
    return {
      UserSearch: UserSearch,
      isSearchAlert: false,
      modelUserSearch: null,
    };
  },
  methods: {
    runner: function () {
      sessionStorage.setItem("runnerName", this.modelUserSearch);
      document.getElementById("js-form").action = `/${this.langPath}${
        this.$route.path.includes("company") ? "company/" : ""
      }ranking/runner`;
    },
  },
  watch: {
    modelUserSearch: function () {
      this.isSearchAlert = false;
    },
  },
  props: {
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
  },
  name: "UserSearch",
};
</script>

<style scoped>
.sub-title {
  margin: 0 15px;
}
.search-form {
  margin: 25px 15px 0 15px;
  padding: 25px;
  background-color: var(--defaultGrayColor);

  .search-box {
    width: 100%;
    height: 45px;
    padding: 0 0 0 10px;
    border: none;
    font-size: 16px;
    background-color: var(--defaultWhiteColor);

    &::placeholder {
      font-size: 14px;
      color: var(--placeholderColor);
      @media screen and (max-width: 350px) {
        font-size: 12px;
      }
    }
  }

  .search-button {
    margin: 15px 0 0 0;
    text-align: center;

    .button {
      width: 120px;
      height: 45px;
      font-size: 16px;
      color: var(--defaultBlackColor);
      border: solid 1px var(--defaultBlackColor);
      background-color: var(--defaultWhiteColor);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sp/ranking/UserSearch.vue